<template>
  <div
    class="Accordian flex flex-wrap w-full h-full"
  >
    <div
      v-for="(slide, index) in dataComputed" :key="index"
      @click="selectSlide(slide)"
      class="w-12 h-full border-l border-black transition-all duration-500 ease-in-out flex items-start justify-start"
      :class="{
        'flex-1':slide.active,
      }"
    >
      <div
        @mouseover="slideHovered(index)"
        @mouseleave="slideUnhovered(index)"
        class="flex items-start h-full w-10 bg-white"
        :class="{
          'cursor-pointer': !slide.active
        }"
      >
        <p class="text-base uppercase flex justify-end w-full transition-all transform -rotate-90 font-bold pr-2 whitespace-no-wrap duration-300"
        :class="{
          'translate-y-2': hoveredSlides[index]&&!slide.active
        }"
        >
          {{slide.name}}
        </p>
        <div class="ml-10 h-full flex flex-wrap content-between">
          <transition name="slideContent">
            <div class="w-full" v-if="slide.active">
              <h1 class="leading-none">{{slide.name}}</h1>
            </div>
          </transition>
          <transition name="slideContent">
            <div class="w-full" v-if="slide.active">
              <span class="leading-9" v-html="slide.content"></span>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordianTwo',
  props: {
    accordianData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      currentSlide: this.accordianData[0],
      dataModified: this.accordianData,
      hoveredSlides: []
    }
  },
  computed: {
    dataComputed () {
      var toReturn = []
      var listToLoop = this.dataModified
      for (var i = 0; i < listToLoop.length; i++) {
        if (this.currentSlide === listToLoop[i]) listToLoop[i].active = true
        else listToLoop[i].active = false

        toReturn.push(listToLoop[i])
        this.slideUnhovered(i)
      }
      return toReturn
    }
  },
  methods: {
    selectSlide (slide) {
      this.currentSlide = slide
      this.$emit('onClick', slide.name)
    },
    slideHovered (slideIndex) {
      this.hoveredSlides[slideIndex] = true
      this.$forceUpdate()
    },
    slideUnhovered (slideIndex) {
      this.hoveredSlides[slideIndex] = false
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss">
</style>
